import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
  ViewChild,
  ViewEncapsulation
}                                 from '@angular/core';
import {ApDynformsComponent}      from '../../ap-dynforms/ap-dynforms.component';
import {ApDynformsConfigFieldset} from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {Subscription}             from 'rxjs';
import {ContactInformationStore}  from '../../stores/common/contactinformation.store';
import {MapViewStore}             from '../../stores/layout/mapview.store';
import {TranslationStore}         from '../../stores/translation/translation.store';
import {MapStore}                 from '../../stores/map/map.store';

@Component({
  selector: 'ap-info-imprint',
  template: `
    <ap-dynforms [fieldsets]="formConfig" [caption]="'Lbl_ImprintText'">
      <div dynforms.after>
        <div #imprint_text></div>
      </div>
    </ap-dynforms>
    <ap-info-version></ap-info-version>
  `,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None
})
export class InfoImprintComponent implements OnDestroy, AfterContentInit {
  @ViewChild(ApDynformsComponent, {static: true}) dynForm: ApDynformsComponent;
  @ViewChild('imprint_text', {static: true, read: ElementRef}) imprintTextElement: ElementRef;
  public formConfig: ApDynformsConfigFieldset[];
  public imprintText: string;
  public loading$;
  private _subscriptions: Array<Subscription> = [];

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2,
              private translationService: TranslationStore,
              private mapViewStore: MapViewStore,
              private mapStore: MapStore,
              private contactInformationStore: ContactInformationStore) {
    this.mapViewStore.showMapView();
  }

  ngAfterContentInit(): void {
    this.loading$ = this.contactInformationStore.Listen(s => s.loading);
    this.contactInformationStore.loadContactInformation();
    this.getDataFromStore();
    this.imprintText = this.translationService.FindTranslationForSelectedLanguage('Global_Imprint_Text');
    (this.imprintTextElement.nativeElement as HTMLDivElement).innerHTML = this.imprintText;
  }

  getDataFromStore(): void {
    this._subscriptions.push(this.contactInformationStore.Listen(s => s.data).subscribe(async infos => {
      if (!infos) {
        return;
      }
      await this.mapStore.Layers.ContactLayer.replaceSource(infos);
      this.mapStore.Layers.ContactLayer.ZoomIn(2500);
      this.formBuilder();
    }));
  }

  ngOnDestroy(): void {
    this.mapStore.Layers.ContactLayer.clear();
    this._subscriptions.forEach(d => {
      d.unsubscribe();
    });
  }

  formBuilder(): void {
    this.formConfig = [];
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'imprint_fieldset',
        columns: 1,
        legend: '',
        label: 'Global_Imprint_Tip',
        config: []
      })
    ];
  }
}
